<template>
    <vx-expandable-card>
        <template v-slot:header> Target Teams </template>
        <template v-slot:content>
            <vx-selectable
                v-model="model.target_teams"
                :options="teams"
                @search="searchTeams"
                @option:deselected="deselectCloningTargets"
                :error="displayFirstError(validate.target_teams)"
                label="name"
                multiple
                size="lg"
                :closeOnSelect="false"
            ></vx-selectable>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { VxExpandableCard, VxSelectable } from '@voxie/frontend-components';
import useVuelidate from '@vuelidate/core';
import { helpers, maxLength, required } from '@vuelidate/validators';
import { computed, onUnmounted } from 'vue';
import { useSearchRequest } from '~/composables/useSearchRequest';
import { adminCloningClient } from '~/services';
import { displayFirstError } from '~/utils/validation';

const model = defineModel('form', {
    type: Object,
    required: true,
});

const validate = useVuelidate(
    {
        target_teams: {
            required,
            maxLength: helpers.withMessage('Target Teams should not contain more than 500 teams.', maxLength(500)),
        },
    },
    model
);

const { response, createSearch, cancelSearch, cancelKey } = useSearchRequest(adminCloningClient, 'clone-teams', 350);
const teams = computed(() => response.value ?? []);
const searchTeams = createSearch(async (search) => {
    const { data } = await adminCloningClient.getTeams(
        {
            query: search,
            sort_field: 'id',
            sort_dir: 'desc',
            per_page: 100,
        },
        { cancelKey }
    );

    return data.data.map((team) => ({
        ...team,
        name: `${team.id} - ${team.name}`,
    }));
});

searchTeams('');

onUnmounted(() => cancelSearch());

const deselectCloningTargets = (targetTeam) => {
    model.value.cloning_targets = model.value.cloning_targets.filter(
        (cloningTarget) => !cloningTarget.teams.some((t) => t.id === targetTeam.id)
    );
};
</script>
